var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "button",
      class: {
        "is-loading": _vm.isProcessingJump,
        "is-current": _vm.isCurrentLocal && _vm.highlightIfCurrent,
      },
      attrs: {
        type: "button",
        disabled: _vm.isLoading || _vm.isProcessingJump || _vm.isCurrentLocal,
      },
      on: {
        click: function ($event) {
          return _vm.jump(_vm.number)
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }